import { ApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { AccessLog, EmailLog, SMSLog } from './logsMangement.types';

type LogFetcher<T> = (client: AxiosInstance) => () => Promise<ApiResponse<T[]>>;

const createLogFetcher = <T>(endpoint: string): LogFetcher<T> => {
  return (client) => async () => (await client.get<ApiResponse<T[]>>(endpoint)).data;
};

const createLogQueryOptions = <T>(key: string, endpoint: string) =>
  queryFactoryOptions<ApiResponse<T[]>>({
    queryKey: [endpoint, key],
    queryFn: (client) => createLogFetcher<T>(endpoint)(client),
  });

export const logQueries = {
  access: createLogQueryOptions<AccessLog>('list', '/access/logs'),
  email: createLogQueryOptions<EmailLog>('list', '/emails/logs'),
  sms: createLogQueryOptions<SMSLog>('list', '/sms/logs'),
};
